import { DsquaresLogo } from "src/assets/Icons";
import UserPoints from "../../UserPoints/UserPoints";
import BurgerMenu from "../../BurgerMenu/BurgerMenu";
import { Link } from "react-router-dom";

export default function LandingNavBarWeb() {
  return (
    <div className="flex items-center justify-between gap-5 px-5 py-5 md:px-20 bg-background-default w-full" dir="ltr">
      <div>
        <Link className="flex items-center justify-center" to="/">
          <DsquaresLogo className="aspect-auto h-12" />
        </Link>
      </div>
      <div className="flex items-center justify-end gap-2">
        <UserPoints />
        <BurgerMenu />
      </div>
    </div>
  );
}
